import { useRef, useState, useEffect } from "react";
import Skeleton from "react-loading-skeleton";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import RouteApi from "../Backend/Backend";
import { useParams } from "react-router-dom";

const CbtList = ({ cbtList, loadCbtList }) => {
  const { deleteCbtByToken } = RouteApi();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  const { id } = useParams();

  useEffect(() => {
    if (cbtList && cbtList.length > 0) {
      setTimeout(() => {
        setLoading(false);
      }, 1200); // Simulate load delay
    }
  }, [cbtList]);

  const handleDeleteCbt = async (tokenId) => {
    if (!window.confirm("Are you sure you want to delete this CBT?")) return;

    const res = await deleteCbtByToken(tokenId);

    if (res.success) {
      toast.success("✅ CBT deleted successfully");
      loadCbtList();
    } else {
      toast.error("❌ Failed to delete CBT");
    }
  };

  const liveCbts = cbtList?.filter(
    (cbt) => cbt.status_code?.toLowerCase() === "live"
  );

  return (
    <div className="mt-4 col-12 position-relative">
      <div className="text-gray-700 fs-4 fw-semibold mb-4">
        <div className="px-lg-4">
            All Live CBTs
        </div>
      </div>

      <div className="px-2 px-lg-0">
        {loading ? (
          <div className="row g-4 py-3 px-3 px-lg-6">
           {[1, 2, 3].map((i) => (
            <div
                key={i}
                className="d-flex align-items-center mb-3 bg-light rounded"
                style={{ minHeight: "60px" }}
            >
                <Skeleton circle width={40} height={40} className="me-3" />
                <div style={{ flex: 1 }}>
                <Skeleton height={16} width="50%" />
                <Skeleton height={14} width="30%" className="mt-1" />
                </div>
            </div>
            ))}
          </div>
        ) : liveCbts?.length > 0 ? (
          <div className="row g-4 px-lg-3">
            {liveCbts.map((cbt, index) => (
              <div className="col-12 col-md-12 col-lg-12" key={index}>
                <div
                  onClick={() =>
                    window.open(`/#/${id}/cbt/console/${cbt.token_id}`, "_blank")
                  }
                  className="card bg-back p-4 text-center position-relative overflow-hidden shadow-sm cursor-pointer"
                  style={{
                    borderRadius: "20px",
                    color: "white",
                  }}
                >
                  <i
                    className="bi bi-journal-text position-absolute"
                    style={{
                      fontSize: "5rem",
                      top: "-20px",
                      right: "-20px",
                      transform: "rotate(-25deg)",
                      opacity: 0.15,
                      pointerEvents: "none",
                      color: "#6c757d",
                    }}
                  ></i>
                  <div className="fs-4 fw-semibold text-purple2 mb-1">{cbt.title}</div>
                  <div className="text-light small text-dark fs-5">
                    {cbt.cbt_subject} • {cbt.timer} mins
                  </div>
                  <div className="text-dark small fs-5">{cbt.task_type}</div>
                </div>

              </div>
            ))}
          </div>
        ) : (
          <div className="text-center text-gray fs-3 mt-10 fw-semibold mb-4">No live CBTs found.</div>
        )}
      </div>
    </div>
  );
};

export default CbtList;
